<script>
  export var settings;
  export var createRec;
  // export var createColMap;
  export var save;

  import {
    Button,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Card,
    Col,
Table,
  } from "sveltestrap";
  import { Form, FormGroup, FormText, Label } from "sveltestrap";
  import SimpleDataSetWidget from "./SimpleDataSetWidget.svelte";
  import { uuidv4 } from "./utils.js";

  let selected = [];

  function createDatasource() {
    // for team ones - ?
    // from("/sources", { method:"POST", body: JSON.stringify(obj)})
    // .then(r => r.json())
    // .then(r => {
    //   state.openrecs = [...state.openrecs, {label: "Untitled-"+state.openrecs.length, name:"Untitled-"+state.openrecs.length, id: newRecId()}];
    //   activeTabId = state.openrecs[state.openrecs.length-1].id;
    // })

    settings.data = [...settings.data, {
      id: uuidv4(),
      name: null,
      type: null,
      saved: false,
    }]
  }

  function remove(id) {
    settings.data = settings.data.filter(x => x.id != id)
  }

  function recSelected() {
    createRec({a:selected[0], b:selected[1]});
  }

  function mapSelected() {
    createRec({a:selected[0], b:selected[1], config: {mode:"colMap"}});
  }

  function select(instance) {
    selected = [...selected, instance];
  }

  function unselect(instance) {
    selected = selected.filter(s => s.uri != instance.uri);
  }

// $: console.log({selected})
</script>

Data sources available 
<div class="p-2" style="background-color: #0001">
  <div class=""  style="display: inline-block">
    <Button size="sm" on:click={createDatasource}>New</Button>
  </div>
  <div class="float-right" style="display: inline-block">
    <span>{selected.length} selected</span>&nbsp;&nbsp;
    <Button size="sm" on:click={mapSelected} disabled={selected.length != 2}>Map columns</Button>
    <Button size="sm" on:click={recSelected} disabled={selected.length != 2}>Rec selected</Button>
  </div>
</div>
Current: 
{#if settings.data.length == 0}
  None
{:else}
  <Table class="table-sm">
    <tr>
      <th>Name</th>
      <th>Date/time</th>
      <th>Type</th>
      <th>Columns</th>
      <th>Rows</th>
      <th>Errors</th>
      <th>Action</th>
    </tr>
  {#each settings.data as data}
  <SimpleDataSetWidget bind:data remove={()=>remove(data.id)} save={()=>save()} select={select} unselect={unselect} />
  {/each}
  </Table>
{/if}

<!-- <Button on:click={()=>settings.modcount++}>{settings.modcount}</Button> -->
